module.exports = __webpack_public_path__ + "static/level-1-logo.ff96eb73.png";